import { personName, themeCommand } from "@nexxt/app-kit";
import { Button, DropdownMenu, useSidebarRail } from "@nexxt/ui";
import { CircleUser, Ellipsis, LogOut, Moon } from "lucide-react";
import { m } from "../../paraglide/messages.js";
import { signOut, useMe } from "../features/auth/me";
import { useDigestItem } from "../features/digest/digest-item";

// Who is signed in, and a menu with the theme, the weekly digest (ADR-316 §8) and the way out. In the sidebar the
// name stays in view next to the menu; in the top bar (`compact`) the icon of the user opens the menu, which names the
// user on top.

export function UserMenu({ compact = false }: { compact?: boolean }) {
  const rail = useSidebarRail();
  const theme = themeCommand();
  const digest = useDigestItem();
  const menu = (
    <DropdownMenu
      align={rail ? "start" : "end"}
      trigger={
        <Button variant="ghost" size="icon" aria-label={m.user_menu()} className="text-muted-foreground">
          {compact ? <CircleUser aria-hidden /> : <Ellipsis aria-hidden />}
        </Button>
      }
      {...(compact && { header: <UserSummary /> })}
      items={[
        { id: "theme", label: theme.label, icon: <Moon aria-hidden />, onSelect: theme.run },
        ...(digest ? [digest] : []),
        { id: "sign-out", label: m.sign_out(), icon: <LogOut aria-hidden />, onSelect: () => void signOut() },
      ]}
    />
  );
  if (compact) return menu;
  return (
    <div className="flex items-center gap-2 pl-2">
      <div className="min-w-0 flex-1">
        <UserSummary />
      </div>
      {menu}
    </div>
  );
}

function UserSummary() {
  const me = useMe();
  return (
    <div className="min-w-0 text-xs">
      <p className="truncate font-medium">{personName(me)}</p>
      <p className="truncate text-muted-foreground">{me.organization.name}</p>
    </div>
  );
}
